// src/admin/components/ErrorState.jsx
//
// Shown when an Admin Dashboard API call fails. Provides a Retry button
// that re-runs whatever fetch function the caller passes in.

import React from 'react';

export default function ErrorState({
  title = 'Unable to load dashboard.',
  message,
  onRetry,
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-red-200 bg-red-50 px-6 py-10 text-center">
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-red-100 text-red-600">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="h-5 w-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86l-8.18 14.18A2 2 0 0 0 3.82 21h16.36a2 2 0 0 0 1.71-2.96L13.71 3.86a2 2 0 0 0-3.42 0z" />
        </svg>
      </div>

      <p className="text-sm font-semibold text-red-700">{title}</p>
      {message && <p className="max-w-sm text-xs text-red-500">{message}</p>}

      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 inline-flex items-center gap-1.5 rounded-lg bg-[#11A8A4] px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#0D8F8C] focus:outline-none focus:ring-2 focus:ring-[#11A8A4] focus:ring-offset-2"
        >
          Retry
        </button>
      )}
    </div>
  );
}
